export function Wordmark({ size = 26, inverse = false }: { size?: number; inverse?: boolean }) {
  return (
    <a href="/" className={`inline-flex items-center gap-2.5 ${inverse ? 'text-[var(--color-side-fg)]' : 'text-ink'}`} aria-label="Kontto">
      <svg width={size} height={size} viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect width="72" height="72" rx="22" fill="#20717A" />
        <rect x="12" y="39" width="28" height="18" rx="8" fill="#EFF2F3" opacity="0.32" />
        <rect x="22" y="27" width="28" height="18" rx="8" fill="#EFF2F3" opacity="0.68" />
        <rect x="32" y="15" width="28" height="18" rx="8" fill="#EFF2F3" />
        <rect x="46" y="22" width="10" height="4" rx="2" fill="#E8927C" />
      </svg>
      <span className="text-[19px] leading-none font-bold tracking-[-0.025em]">Kontto</span>
    </a>
  );
}
